import { combineReducers } from "redux";
import auth from "./auth";
import offers from "./offers";
import workers from "./workers";
import configuration from "./configuration";

export default combineReducers({ auth, workers, offers, configuration});
